export default __webpack_public_path__ + "static/media/photo--lg--68.6e09ea98.jpg";